import { useEffect, useState } from 'react';

/**
 * Returns true after the component has mounted on the client.
 * Use to prevent hydration mismatches when rendering client-only data
 * (cookies, localStorage, browser APIs, etc.).
 *
 * @example
 * ```tsx
 * const hasMounted = useHasMounted();
 *
 * // Ensure server and initial client render match
 * if (!hasMounted) {
 *   return <Skeleton />;
 * }
 *
 * // Safe to use client-only data after mount
 * return <div>{clientOnlyValue}</div>;
 * ```
 */
export function useHasMounted(): boolean {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return hasMounted;
}
